import { render } from "./BaseRadio.vue?vue&type=template&id=4f0f5afa"
import script from "./BaseRadio.vue?vue&type=script&lang=js"
export * from "./BaseRadio.vue?vue&type=script&lang=js"
script.render = render

export default script